import { ActionCreator, AnyAction } from 'redux'

import { actionTypes } from 'actions/actionTypes'
import { signupByPaymentMethod } from 'actions/trackingKeys'

export const trackSignupByPaymentMethod: ActionCreator<AnyAction> = (paymentMethod: string) => ({
  type: actionTypes.TRACKING,
  trackingData: { actionType: signupByPaymentMethod, paymentMethod },
})
